import React, { Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';

import './Home.css';


const ClinicianInfo = (props) => {
    // Don't display the logo if not present.  Note the clever trick to optionally include the logo below in the render method!
    let logoColSize = 4;
    let organizationColSize = 8;

    if (isNullOrEmpty(props.organizationLogo)) {
        logoColSize = 0;
        organizationColSize = 12;
    }

    return (
        <Fragment>
            <Col sm={logoColSize}>
                {!isNullOrEmpty(props.organizationLogo) &&
                    <img src={props.organizationLogo} alt="organization Logo" />
                }
            </Col>
            <Col sm={organizationColSize}>
                <h2>{props.organizationName}</h2>
                <h4 className="home_clinicianName">{props.userDisplayName}</h4>
                {!props.isCaregiverOrRater && false &&
                    <div className="home_clinicianSummary">
                        <Container>
                            <Row>
                                <Col sm={3}>
                                    <p>Total Patients Assessed</p>
                                </Col>
                                <Col sm={1}>
                                    <p className="home_clinicianSummaryValue" >{props.totalPersonsAssessed}</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={3}>
                                    <p>Total Assessments</p>
                                </Col>
                                <Col sm={1}>
                                    <p className="home_clinicianSummaryValue" >{props.totalAssessments}</p>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                }
            </Col>

        </Fragment>
    )
}

export default ClinicianInfo;


// WEBPACK FOOTER //
// ./src/components/Home/ClinicianInfo.js